import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.string
};

const ModalWrapper = ({children, className = '', variant = null}) => {
  const previewClass = cx(className, styles.preview, 'modal-btn-wrapper', {
    [styles.preview]: variant === null,
    [styles[`${variant}`]]: variant !== null
  });

  return <div className={previewClass}>{children}</div>;
};

ModalWrapper.propTypes = propTypes;

export default ModalWrapper;
